import { ForgotPasswordFormV2, Props } from './forgot-password-form-v2';

export const ForgotPasswordContainerV2 = (props: Props) => {
  return <ForgotPasswordFormV2 {...props} />;
};
